export * from "./strategy-group";
export * from "./activity";
export * from "./category-group";
export * from "./grp";
export * from "./no-setting";
export * from "./sales-scale";

export const borderAppearance = 3;
